
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import get from 'lodash/get';

import categoryGetActions from '../../sagas/category';
import CategoryComboBox from '../common/CategoryComboBox';
import DialogConfirm from '../common/DialogConfirm';
import ToolbarCommandButton from '../projectMapPage/ToolbarCommandButton'; // ToDo
import DialogCreateCategory from './DialogCreateCategory';
import DialogCreateCategoryItem from './DialogCreateCategoryItem';
import CategoryItems from './CategoryItems';
import OverviewPanel from './OverviewPanel';

const classNames = mergeStyleSets({
    content: {
        paddingTop: 16
    }
});

const OverviewPanelCategory = (props) => {

    const [previousCategoryName, setPreviousCategoryName] = useState();
    const [actualCategoryName, setActualCategoryName] = useState();

    const dispatch = useDispatch();
    const categoryActions = categoryGetActions(dispatch);

    const token = useSelector(state => {
        return state.auth.data ? state.auth.data.user.token : null;
    });

    const projectId = useSelector(state => {
        return state.project.data.project.id;
    });

    const category = useSelector(state => {
        return state.category;
    });

    const categories = get(category, 'data.result.category.categories', []);
    const categoryItems = category.categoryItems
        ? category.categoryItems[actualCategoryName]
        : [];
    const actualCategory = categories.reduce((previous, current) => {
        return (current.name === actualCategoryName)
            ? current
            : previous;
    }, null);

    useEffect(() => {
        if (!category.loaded && !category.loading) {
            categoryActions.categoryGet(token, projectId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [category]);

    const handleChangeCategory = (category) => {
        setActualCategoryName(category);
        if (category) {
            setPreviousCategoryName(category);
        }
    }

    const handleCreateClick = async () => {
        const data = await DialogCreateCategory.show();
        if (data) {
            categoryActions.createCategory(token, projectId, data.title);
        }
    }

    const handleCreateItemClick = async () => {
        const data = await DialogCreateCategoryItem.show();
        if (data) {
            categoryActions.createCategoryItem(
                token, projectId, actualCategoryName, data.title, data.color
            );
        }
    }

    const handleDeleteClick = async () => {
        const message = `Opravdu chcete smazat kategorii parcel "${actualCategory.title}"? Data budou nenávratně smazána.`;

        let confirm = await DialogConfirm.show(message);
        if (confirm) {
            categoryActions.deleteCategory(token, projectId, actualCategoryName);
        }
    }

    return (
        <OverviewPanel title="KATEGORIE PARCEL" loaded={category.loaded}>
            <Stack className={classNames.content} tokens={{childrenGap: 16}}>
                <CategoryComboBox
                    categories={categories}
                    onChangeCategory={handleChangeCategory}
                    selectedCategory={actualCategoryName || previousCategoryName}
                />
                <CategoryItems
                    actualCategoryName={actualCategoryName}
                    categoryItems={categoryItems}
                />
                <ToolbarCommandButton items={[
                    {
                        text: 'Nová kategorie',
                        title: 'Vytvořit novou kategoorii parcel',
                        onClick: handleCreateClick
                    },
                    {
                        text: 'Nová položka',
                        title: 'Vytvořit novou položku vybrané kategorie parcel',
                        onClick: handleCreateItemClick
                    },
                    {
                        text: 'Smazat',
                        title: 'Smazat vybranou kategoorii parcel',
                        onClick: handleDeleteClick
                    }
                ]}/>
            </Stack>
        </OverviewPanel>
    );
}

export default OverviewPanelCategory;
